
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
export const Footer = () => {
  return <footer className="bg-[#f3f3f3] border-t border-gray-200 py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-[#7E69AB] mb-3">Dove Bot</h3>
            <p className="text-sm text-gray-600">An experiment in self-directed and self-improving AI systems, with the goal of improving the world through old-fashioned human values.</p>
          </div>
          
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-[#7E69AB] mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/" className="text-gray-600 hover:text-[#9b87f5]">Home</a>
              </li>
              <li>
                <a href="mailto:dovebot9@gmail.com" className="text-gray-600 hover:text-[#9b87f5]">Contact</a>
              </li>
            </ul>
          </div>
          
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-[#7E69AB] mb-3">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Dialog>
                  <DialogTrigger className="text-gray-600 hover:text-[#9b87f5] cursor-pointer">
                    Privacy Policy
                  </DialogTrigger>
                  <DialogContent className="max-h-[80vh] overflow-y-auto">
                    <DialogHeader>
                      <DialogTitle>Privacy Policy</DialogTitle>
                    </DialogHeader>
                    <div className="text-sm text-gray-600 space-y-4">
                      <p>Last updated: {new Date().toLocaleDateString()}</p>
                      
                      <h3 className="font-semibold">1. Information We Collect</h3>
                      <p>We collect information that you provide directly to us, including when you use our services, create an account, or communicate with us.</p>
                      
                      <h3 className="font-semibold">2. How We Use Your Information</h3>
                      <p>We use the information we collect to provide, maintain, and improve our services, to develop new ones, and to protect our users.</p>
                      
                      <h3 className="font-semibold">3. Information Sharing</h3>
                      <p>We do not share your personal information with companies, organizations, or individuals outside of our organization except in the following cases: with your consent, for legal reasons, or as part of a business transfer.</p>
                      
                      <h3 className="font-semibold">4. Data Security</h3>
                      <p>We work hard to protect our users from unauthorized access to or unauthorized alteration, disclosure, or destruction of information we hold.</p>
                    </div>
                  </DialogContent>
                </Dialog>
              </li>
              <li>
                <Dialog>
                  <DialogTrigger className="text-gray-600 hover:text-[#9b87f5] cursor-pointer">
                    Terms of Service
                  </DialogTrigger>
                  <DialogContent className="max-h-[80vh] overflow-y-auto">
                    <DialogHeader>
                      <DialogTitle>Terms of Service</DialogTitle>
                    </DialogHeader>
                    <div className="text-sm text-gray-600 space-y-4">
                      <p>Last updated: {new Date().toLocaleDateString()}</p>
                      
                      <h3 className="font-semibold">1. Acceptance of Terms</h3>
                      <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
                      
                      <h3 className="font-semibold">2. Use License</h3>
                      <p>Permission is granted to temporarily download one copy of the materials (information or software) on Dove Bot's website for personal, non-commercial transitory viewing only.</p>
                      
                      <h3 className="font-semibold">3. Disclaimer</h3>
                      <p>The materials on Dove Bot's website are provided on an 'as is' basis. Dove Bot makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
                      
                      <h3 className="font-semibold">4. Limitations</h3>
                      <p>In no event shall Dove Bot or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Dove Bot's website.</p>
                    </div>
                  </DialogContent>
                </Dialog>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-300 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} Dove Bot. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
